export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./phone-number.vue?vue&type=template&id=04a22dc6"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/payments/phone-number.vue?vue&type=template&id=04a22dc6
// module id = nyGs
// module chunks = 0